import { cn } from '@/src/infrastructure/lib/utils';
import type { UserStatus } from '../types';

const COLORS: Record<UserStatus, string> = {
  ACTIVE: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  SUSPENDED: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
  DELETED: 'bg-red-500/15 text-red-300 border-red-500/30',
};

export function UserStatusBadge({ status }: { status: UserStatus | string }) {
  const key = (status as UserStatus) in COLORS ? (status as UserStatus) : 'ACTIVE';
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] uppercase font-bold tracking-widest',
        COLORS[key],
      )}
    >
      {status}
    </span>
  );
}

export function RoleBadge({ role }: { role: string }) {
  const colors =
    role === 'SUPER_ADMIN'
      ? 'bg-fuchsia-500/15 text-fuchsia-300 border-fuchsia-500/30'
      : role === 'ADMIN'
        ? 'bg-violet-500/15 text-violet-300 border-violet-500/30'
        : role === 'EDITOR'
          ? 'bg-blue-500/15 text-blue-300 border-blue-500/30'
          : 'bg-surface-container-high text-on-surface-variant border-border-subtle';
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] uppercase font-bold tracking-widest',
        colors,
      )}
    >
      {role}
    </span>
  );
}

export function PlanBadge({ plan }: { plan: string }) {
  const colors =
    plan === 'PREMIUM'
      ? 'bg-amber-400/15 text-amber-300 border-amber-400/30'
      : plan === 'PRO'
        ? 'bg-electric-violet/15 text-primary border-electric-violet/30'
        : 'bg-surface-container-high text-on-surface-variant border-border-subtle';
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] uppercase font-bold tracking-widest',
        colors,
      )}
    >
      {plan}
    </span>
  );
}
